import { useEffect, type ReactNode } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { useAuth } from './store/auth';
import { useT, useLocale } from './i18n';
import { setMonthNames } from './lib/months';
import { setIntlLocale } from './lib/format';
import { ErrorBoundary } from './components/ErrorBoundary';

function Guarded({ children }: { children: ReactNode }) {
  const { me, loading } = useAuth();
  const location = useLocation();
  const t = useT();
  if (loading) return <div className="loading">{t.common.loading}</div>;
  if (!me) return <Navigate to="/login" state={{ from: location }} replace />;
  return <>{children}</>;
}

export function App() {
  const init = useAuth((s) => s.init);
  const t = useT();
  const locale = useLocale((s) => s.locale);
  useEffect(() => { void init(); }, [init]);
  useEffect(() => { setMonthNames(t.months); }, [t.months]);
  useEffect(() => { setIntlLocale(locale === 'en' ? 'en-US' : 'de-DE'); }, [locale]);

  return (
    <ErrorBoundary label="App-Root">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Guarded><Dashboard /></Guarded>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}
